// @charset "utf-8";
import * as filters from '@/filters'
import Vue from 'vue'
for (let key in filters) {
    Vue.filter(key, filters[key])
}



// WEBPACK FOOTER //
// ./src/lib/filter.js